import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GRAPH_TYPES, REPORT_TYPES, SOCIAL_SOURCES } from "../../../constants/app-constant";
import { AreaChart } from "./area-chart";
import { BarChartHorizontal } from "./bar-chart-horizontal";
import { BarChartVertical } from "./bar-chart-vertical";
import { DoughnutChart } from "./doughnut-chart";
import { GenderChart } from "./gender-chart";
import InfluencerChart from "./influencer-chart";
import { LineChart } from "./line-chart";
import { MapChart } from "./MapCharts";
import { PieChart } from "./pie-chart";
import ReachChart from "./reach-chart";
import TopPostersChart from "./top-posters-chart";
import { StackedBarChart } from "./stacked-bar-chart";
import { TableChart } from "./table-chart";
import { WordCloudGraph } from "./wordcloud";
import {
  StackedBarChartHC,
  StackedBarChartHCEqualHeight,
  LineChartHC,
  HorizontalBarChartHC,
  DoughnutChartHC,
  PieChartHC,
  VerticalBarChartHC,
  AreaChartHC,
  WordCloudHC,
} from "./highcharts/index";
// import KeyInfluencerChart from "./keyinfluencer-chart";
import {
  convertToInternationalCurrencySystem,
  relDiff,
} from "../../../utility/common-methods";
import AuthorFollowingChart from "./author-following";
import AuthorTweetCountChart from "./Author-Tweet-Count";
import AuthorListedChart from "./Author-Listed";
import AuthorLikeChart from "./Author-Like";
import AuthorCreatedChart from "./Author-created";

const { FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER, LINKEDIN } = SOCIAL_SOURCES;

const {
  PIE,
  BAR_HORIZONTAL,
  BAR_VERTICAL,
  BAR_STACKED,
  BAR_STACKED_EQUAL_HEIGHT,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
  CHOROPLETH,
  DOUGHNUT,
  INFLUENCERS,
} = GRAPH_TYPES;

export default function WidgetSwitch({
  graph_type,
  graphApiResponse,
  chartTitle,
  onEntityClick,
  report_type,
  entityList,
  editionList,
  showPercentage,
  dataByReportType,
  identifier,
  worldMapData,
  isAnalysisReport,
  selectedDataType,
  isEmbededWidget,
  countryWiseFeeds,
  type,
  setGraphRef,
  setGraphRefList,
  twitterFeeds,
  insightFeeds = 0,
  twitterBreakDown,
  twitterBreakDownPie,
  twitterBreakDownLine,
  selectedFilter,
  reportType,
  twitterMetricsData,
  keyMetrics,
  channelType,
  fromUserName = "",
  setFromUserName,
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  console.log("Widget Switch data is here 102 ",graph_type)
    if (
    reportType === "twitterKeymetrics" &&
    keyMetrics &&
    keyMetrics.length &&
    graph_type === ""
  ) {
    // debugger;
    console.log(
      keyMetrics,
      keyMetrics[0].users,
      convertToInternationalCurrencySystem(keyMetrics[0].users)
    );
  }
  return (
    <div
      className={`widget-graph-container ${
        graph_type === TABLE ? "wgcWithTable" : ""
      }`}
    >
      <div className="widget-graph-inner" style={graph_type === TABLE && report_type == REPORT_TYPES.TopPostersWithDetail?{width:'100%'}:{}}>
        {reportType === "twitterKeymetrics" &&
          keyMetrics &&
          keyMetrics.length &&
          graph_type === "" && (
            <>
              <div class="container" style={{ textAlign: "center" }}>
                {/* <div class="row graph-wraper">
                    <div class="col-md-6"></div>

                    <div class="col-md-6"> */}
                <h1
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "50px",
                  }}
                >
                  <b>
                    Key Metrics for X<span class="icon"></span>
                  </b>
                </h1>

                <Row style={{ marginBottom: "30px" }}>
                  <Col>
                    <>
                      <div class="metrics-content">
                        <h4>
                          {convertToInternationalCurrencySystem(
                            keyMetrics[0].users
                          )}
                        </h4>
                        <p>
                          Users<span class="icon"></span>
                        </p>
                      </div>
                    </>
                  </Col>
                  <Col>
                    <div class="metrics-divide-line"></div>
                  </Col>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].impressions
                        )}
                      </h4>
                      <p>
                        Impressions<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].mentions
                        )}
                      </h4>
                      <p>
                        Mentions<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                  <Col>
                    <div class="metrics-divide-line"></div>
                  </Col>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].reach
                        )}
                      </h4>
                      <p>
                        Reach<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].likes
                        )}
                      </h4>
                      <p>
                        Likes<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                </Row>

                {/* <div class="col-sm-3">
                        <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].users).toLocaleString("en")}</h4>

                <p>
                  Users<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].mentions).toLocaleString("en")}</h4>

                <p>
                  Mentions<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>
                  {parseInt(keyMetrics[0].impressions).toLocaleString("en")}
                </h4>

                <p>
                  Impressions<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].reach).toLocaleString("en")}</h4>

                <p>
                  Reach<span class="icon"></span>
                </p> */}
                {/* </div>
                      </div>

                      <div class="col-sm-9"></div>
                    </div>
                  </div> */}
              </div>
            </>
          )}
        {reportType === "linkedinKeymetrics" &&
          keyMetrics &&
          keyMetrics.length &&
          graph_type === "" && (
            <>
              <div class="container" style={{ textAlign: "center" }}>
                {/* <div class="row graph-wraper">
                    <div class="col-md-6"></div>

                    <div class="col-md-6"> */}
                <h1
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "50px",
                  }}
                >
                  <b>
                    Key Metrics for {report_type === REPORT_TYPES.FACEBOOK_METRICS?"Facebook":(report_type === REPORT_TYPES.LINKEDIN_METRICS?"LinkedIn":(report_type === REPORT_TYPES.INSTAGRAM_METRICS?"Instagram":""))}<span class="icon"></span>
                  </b>
                </h1>

                <Row style={{ marginBottom: "30px" }}>
                {report_type !== REPORT_TYPES.INSTAGRAM_METRICS?
                  <>
                    <Col>
                      <>
                        <div class="metrics-content">
                          <h4>
                            {convertToInternationalCurrencySystem(
                              keyMetrics[0].users
                            )}
                          </h4>
                          <p>
                            Users<span class="icon"></span>
                          </p>
                        </div>
                      </>
                    </Col>
                    <Col>
                      <div class="metrics-divide-line"></div>
                    </Col>
                  </>
                  :""}
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].comment_count
                        )}
                      </h4>
                      <p>
                        Comment's<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].mentions
                        )}
                      </h4>
                      <p>
                        Mentions<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                  <Col>
                    <div class="metrics-divide-line"></div>
                  </Col>
                  <Col>
                    <div class="metrics-content">
                      <h4>
                        {convertToInternationalCurrencySystem(
                          keyMetrics[0].attachment
                        )}
                      </h4>
                      <p>
                        Attachment<span class="icon"></span>
                      </p>
                    </div>
                  </Col>
                </Row>

                {/* <div class="col-sm-3">
                        <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].users).toLocaleString("en")}</h4>

                <p>
                  Users<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].mentions).toLocaleString("en")}</h4>

                <p>
                  Mentions<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>
                  {parseInt(keyMetrics[0].impressions).toLocaleString("en")}
                </h4>

                <p>
                  Impressions<span class="icon"></span>
                </p> */}
                {/* </div> */}

                {/* <div class="list"> */}
                {/* <h4>{parseInt(keyMetrics[0].reach).toLocaleString("en")}</h4>

                <p>
                  Reach<span class="icon"></span>
                </p> */}
                {/* </div>
                      </div>

                      <div class="col-sm-9"></div>
                    </div>
                  </div> */}
              </div>
            </>
          )}
        {graph_type === DOUGHNUT && (
          <>
            <DoughnutChartHC
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              selectedDataType={selectedDataType}
              dataByReportType={dataByReportType}
              showPercentage={showPercentage}
              isEmbededWidget={isEmbededWidget}
              type={type}
              identifier={identifier}
              setGraphRef={setGraphRef}
              setGraphRefList={setGraphRefList}
              mediaType={type}
              to_date={to_date}
              from_date={from_date}
              dateHash={dateHash}
              widget={widget}
              selectedInlineJournalist={selectedInlineJournalist}
              selectedInlinePlatform={selectedInlinePlatform}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineSentiment={selectedInlineSentiment}
              isBlogAndForum={isBlogAndForum}
              isSocial={isSocial}
              selectedInlineWCType={selectedInlineWCType}
            />
            {/* <DoughnutChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              selectedDataType={selectedDataType}
              dataByReportType={dataByReportType}
              showPercentage={showPercentage}
              isEmbededWidget={isEmbededWidget}
              type={type}
            /> */}
          </>
        )}
        {graph_type === PIE &&
          (!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) ? (
            <>
              <PieChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                onEntityClick={onEntityClick}
                entityList={entityList}
                showPercentage={showPercentage}
                selectedDataType={selectedDataType}
                isEmbededWidget={isEmbededWidget}
                identifier={identifier}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
              {/* <PieChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              onEntityClick={onEntityClick}
              entityList={entityList}
              showPercentage={showPercentage}
              selectedDataType={selectedDataType}
              isEmbededWidget={isEmbededWidget}
            /> */}
            </>
          ) : (insightFeeds != undefined && insightFeeds !== 0?
            <>
              <PieChartHC
                chartTitle={chartTitle}
                insightFeeds={insightFeeds}
                data={twitterBreakDownPie}
                reportType={report_type}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                onEntityClick={onEntityClick}
                selectedFilter={selectedFilter}
                isEmbededWidget={isEmbededWidget}
                selectedDataType={selectedDataType}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            </>
            :<>
              <PieChartHC
                chartTitle={chartTitle}
                twitterFeeds
                data={twitterBreakDownPie}
                reportType={report_type}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                onEntityClick={onEntityClick}
                selectedFilter={selectedFilter}
                isEmbededWidget={isEmbededWidget}
                selectedDataType={selectedDataType}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            </>
          ))}
        {graph_type === BAR_VERTICAL && (
          <>
       
            {!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) ? (
              <VerticalBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            ) : (
              // {/* <BarChartVertical
              //   graphApiResponse={graphApiResponse}
              //   chartTitle={chartTitle}
              //   yAxisMin={0}
              //   beginAtZero
              //   onEntityClick={onEntityClick}
              //   reportType={report_type}
              //   entityList={entityList}
              //   dataByReportType={dataByReportType}
              //   editionList={editionList}
              //   isEmbededWidget={isEmbededWidget}
              // /> */}
              (insightFeeds != undefined && insightFeeds !== 0?<VerticalBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownPie}
                insightFeeds={insightFeeds}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
              :<VerticalBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownPie}
                twitterFeeds
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />)
            )}
          </>
        )}
        {graph_type === BAR_HORIZONTAL && (
          <>
            <HorizontalBarChartHC
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
              setGraphRef={setGraphRef}
              setGraphRefList={setGraphRefList}
              mediaType={type}
              to_date={to_date}
              from_date={from_date}
              dateHash={dateHash}
              widget={widget}
              selectedInlineJournalist={selectedInlineJournalist}
              selectedInlinePlatform={selectedInlinePlatform}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineSentiment={selectedInlineSentiment}
              isBlogAndForum={isBlogAndForum}
              isSocial={isSocial}
              selectedInlineWCType={selectedInlineWCType}
            />
            {/* <BarChartHorizontal
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */}
          </>
        )}
        {graph_type === LINE &&
          (!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) ? (
            <>
              <LineChartHC
                fromUserName={fromUserName}
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
              {/* <LineChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */}
            </>
          ) : (
            insightFeeds !== undefined && insightFeeds !== 0?
            <>
              {
                reportType == "linkedinKeymetrics" ? (
                  <LineChartHC
                    chartTitle={chartTitle}
                    beginAtZero
                    metricsData={twitterMetricsData}
                    insightFeeds={insightFeeds}
                    reportType={report_type}
                    onEntityClick={onEntityClick}
                    type={reportType}
                    selectedFilter={selectedFilter}
                    setGraphRefList={setGraphRefList}
                    mediaType={type}
                    to_date={to_date}
                    from_date={from_date}
                    dateHash={dateHash}
                    widget={widget}
                    selectedInlineJournalist={selectedInlineJournalist}
                    selectedInlinePlatform={selectedInlinePlatform}
                    selectedInlinePublication={selectedInlinePublication}
                    selectedInlineSentiment={selectedInlineSentiment}
                    isBlogAndForum={isBlogAndForum}
                    isSocial={isSocial}
                    selectedInlineWCType={selectedInlineWCType}
                  />
                ) : (
                  <LineChartHC
                    chartTitle={chartTitle}
                    beginAtZero
                    data={twitterBreakDownLine}
                    insightFeeds={insightFeeds}
                    reportType={report_type}
                    onEntityClick={onEntityClick}
                    selectedFilter={selectedFilter}
                    type={reportType}
                    setGraphRefList={setGraphRefList}
                    mediaType={type}
                    to_date={to_date}
                    from_date={from_date}
                    dateHash={dateHash}
                    widget={widget}
                    selectedInlineJournalist={selectedInlineJournalist}
                    selectedInlinePlatform={selectedInlinePlatform}
                    selectedInlinePublication={selectedInlinePublication}
                    selectedInlineSentiment={selectedInlineSentiment}
                    isBlogAndForum={isBlogAndForum}
                    isSocial={isSocial}
                    selectedInlineWCType={selectedInlineWCType}
                  />
                )
                /* <LineChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */
              }
            </>
            :<>
              {
                reportType == "twitterKeymetrics" ? (
                  <LineChartHC
                    chartTitle={chartTitle}
                    beginAtZero
                    metricsData={twitterMetricsData}
                    twitterFeeds
                    reportType={report_type}
                    onEntityClick={onEntityClick}
                    type={reportType}
                    selectedFilter={selectedFilter}
                    setGraphRefList={setGraphRefList}
                    mediaType={type}
                    to_date={to_date}
                    from_date={from_date}
                    dateHash={dateHash}
                    widget={widget}
                    selectedInlineJournalist={selectedInlineJournalist}
                    selectedInlinePlatform={selectedInlinePlatform}
                    selectedInlinePublication={selectedInlinePublication}
                    selectedInlineSentiment={selectedInlineSentiment}
                    isBlogAndForum={isBlogAndForum}
                    isSocial={isSocial}
                    selectedInlineWCType={selectedInlineWCType}
                  />
                ) : (
                  <LineChartHC
                    chartTitle={chartTitle}
                    beginAtZero
                    data={twitterBreakDownLine}
                    twitterFeeds
                    reportType={report_type}
                    onEntityClick={onEntityClick}
                    selectedFilter={selectedFilter}
                    type={reportType}
                    setGraphRefList={setGraphRefList}
                    mediaType={type}
                    to_date={to_date}
                    from_date={from_date}
                    dateHash={dateHash}
                    widget={widget}
                    selectedInlineJournalist={selectedInlineJournalist}
                    selectedInlinePlatform={selectedInlinePlatform}
                    selectedInlinePublication={selectedInlinePublication}
                    selectedInlineSentiment={selectedInlineSentiment}
                    isBlogAndForum={isBlogAndForum}
                    isSocial={isSocial}
                    selectedInlineWCType={selectedInlineWCType}
                  />
                )
                /* <LineChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */
              }
            </>
          ))}
        {graph_type === AREA && (
          <>
            <AreaChartHC
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
              setGraphRef={setGraphRef}
              setGraphRefList={setGraphRefList}
              mediaType={type}
              to_date={to_date}
              from_date={from_date}
              dateHash={dateHash}
              widget={widget}
              selectedInlineJournalist={selectedInlineJournalist}
              selectedInlinePlatform={selectedInlinePlatform}
              selectedInlinePublication={selectedInlinePublication}
              selectedInlineSentiment={selectedInlineSentiment}
              isBlogAndForum={isBlogAndForum}
              isSocial={isSocial}
              selectedInlineWCType={selectedInlineWCType}
            />
            {/* <AreaChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */}
          </>
        )}
        {graph_type === BAR_STACKED && (
          <>
            {!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) ? (
              <StackedBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            ) : (
              insightFeeds !== 0?
              <StackedBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownLine}
                insightFeeds = {insightFeeds}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
              :
              <StackedBarChartHC
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownLine}
                twitterFeeds
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            )}
            {/* <StackedBarChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              isEmbededWidget={isEmbededWidget}
            /> */}
          </>
        )}
        {graph_type === BAR_STACKED_EQUAL_HEIGHT && (
          <>
            {!twitterFeeds && (insightFeeds == 0 || insightFeeds == undefined) ? (
              <StackedBarChartHCEqualHeight
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            ) : (
              insightFeeds !== 0?
              <StackedBarChartHCEqualHeight
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownLine}
                insightFeeds = {insightFeeds}
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
              :<StackedBarChartHCEqualHeight
                graphApiResponse={graphApiResponse}
                chartTitle={chartTitle}
                beginAtZero
                onEntityClick={onEntityClick}
                reportType={report_type}
                entityList={entityList}
                dataByReportType={dataByReportType}
                editionList={editionList}
                isEmbededWidget={isEmbededWidget}
                setGraphRef={setGraphRef}
                setGraphRefList={setGraphRefList}
                data={twitterBreakDownLine}
                twitterFeeds
                mediaType={type}
                to_date={to_date}
                from_date={from_date}
                dateHash={dateHash}
                widget={widget}
                selectedInlineJournalist={selectedInlineJournalist}
                selectedInlinePlatform={selectedInlinePlatform}
                selectedInlinePublication={selectedInlinePublication}
                selectedInlineSentiment={selectedInlineSentiment}
                isBlogAndForum={isBlogAndForum}
                isSocial={isSocial}
                selectedInlineWCType={selectedInlineWCType}
              />
            )}
          </>
        )}
        {graph_type === TABLE &&
          report_type != REPORT_TYPES.TopPostersWithDetail &&
          report_type != REPORT_TYPES.INFLUENCERS &&
          report_type != REPORT_TYPES.AuthorFollowing &&
          report_type != REPORT_TYPES.AuthorTweetCount &&
          report_type != REPORT_TYPES.AuthorListed &&
          report_type != REPORT_TYPES.AuthorLike &&
          report_type != REPORT_TYPES.AuthorCreated &&
          // report_type != REPORT_TYPES.KEYINFLUENCERS &&
          report_type != REPORT_TYPES.Reach && (
            <TableChart
              graphApiResponse={graphApiResponse}
              chartTitle={chartTitle}
              beginAtZero
              onEntityClick={onEntityClick}
              reportType={report_type}
              entityList={entityList}
              dataByReportType={dataByReportType}
              editionList={editionList}
              countryWiseFeeds={countryWiseFeeds}
              isEmbededWidget={isEmbededWidget}
              type={type}
              setGraphRefList={setGraphRefList}
              mediaType={type}
            />
          )}
        {graph_type === WORD_CLOUD && (
          <WordCloudHC
            graphApiResponse={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            onEntityClick={onEntityClick}
            entityList={entityList}
            isEmbededWidget={isEmbededWidget}
            setGraphRef={setGraphRef}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === GENDER && (
          <GenderChart
            data={graphApiResponse || []}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type == CHOROPLETH && report_type == REPORT_TYPES.WorldMap && (
          <MapChart
            chartTitle={chartTitle}
            identifier={identifier}
            data={worldMapData}
            onEntityClick={onEntityClick}
            isEmbededWidget={isEmbededWidget}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.Reach && (
          <ReachChart
            data={graphApiResponse || []}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.INFLUENCERS && (
          <InfluencerChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
            setFromUserName={setFromUserName}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.AuthorFollowing && (
          <AuthorFollowingChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.AuthorTweetCount && (
          <AuthorTweetCountChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.AuthorListed && (
          <AuthorListedChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.AuthorCreated && (
          <AuthorCreatedChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {graph_type === TABLE && report_type === REPORT_TYPES.AuthorLike && (
          <AuthorLikeChart
            data={graphApiResponse}
            chartTitle={chartTitle}
            identifier={identifier}
            isEmbededWidget={isEmbededWidget}
            onEntityClick={onEntityClick}
            entityList={entityList}
            setGraphRefList={setGraphRefList}
            mediaType={type}
          />
        )}
        {/* {graph_type === TABLE &&
          report_type === REPORT_TYPES.KEYINFLUENCERS && (
            <KeyInfluencerChart
              data={graphApiResponse}
              chartTitle={chartTitle}
              identifier={identifier}
              isEmbededWidget={isEmbededWidget}
              onEntityClick={onEntityClick}
              entityList={entityList}
              setGraphRefList={setGraphRefList}
              mediaType={type}
            />
          )} */}
        {report_type === REPORT_TYPES.TopPostersWithDetail &&
          graph_type != BAR_VERTICAL &&
          graph_type != BAR_STACKED_EQUAL_HEIGHT &&
          graph_type != BAR_STACKED && (
            <TopPostersChart
              data={graphApiResponse}
              chartTitle={chartTitle}
              identifier={identifier}
              isEmbededWidget={isEmbededWidget}
              channelType={channelType}
              onEntityClick={onEntityClick}
              entityList={entityList}
              setFromUserName={setFromUserName}
            />
          )}
      </div>
    </div>
  );
}
